// Router code-based (sin plugin de bundler → compatible con Farm).
// La ruta raíz renderiza el shell (Sidebar + Navbar + FAB) con un <Outlet/>.
// Las rutas se declaran con paths literales para que TanStack infiera el
// type-safety de navegación (Link/useNavigate).
import {
  createRootRouteWithContext, createRoute, createRouter, Outlet,
} from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { queryClient } from './lib/queryClient';
import { AppShell } from './components/AppShell';

import { Dashboard } from './routes/Dashboard';
import { Bodegas } from './routes/Bodegas';
import { Productos } from './routes/Productos';
import { Presentaciones } from './routes/Presentaciones';
import { Inventario } from './routes/Inventario';
import { Traslados } from './routes/Traslados';
import { Movimientos } from './routes/Movimientos';
import { Alertas } from './routes/Alertas';

export interface RouterContext {
  queryClient: QueryClient;
}

const rootRoute = createRootRouteWithContext<RouterContext>()({
  component: () => (
    <AppShell>
      <Outlet />
    </AppShell>
  ),
});

const p = () => rootRoute;
const routeTree = rootRoute.addChildren([
  createRoute({ getParentRoute: p, path: '/', component: Dashboard }),
  createRoute({ getParentRoute: p, path: '/bodegas', component: Bodegas }),
  createRoute({ getParentRoute: p, path: '/productos', component: Productos }),
  createRoute({ getParentRoute: p, path: '/presentaciones', component: Presentaciones }),
  createRoute({ getParentRoute: p, path: '/inventario', component: Inventario }),
  createRoute({ getParentRoute: p, path: '/traslados', component: Traslados }),
  createRoute({ getParentRoute: p, path: '/movimientos', component: Movimientos }),
  createRoute({ getParentRoute: p, path: '/alertas', component: Alertas }),
]);

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  context: { queryClient },
});

// Registro de tipos para el type-safety de TanStack Router.
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
